
export interface UsageData {
    userId: string,
    productCode: string,
    userTotalUsage: number,
    userApiUsageCounter: number,
    userGuiUsageCounter: number
}

export interface RawSubscription {
    dealId: string,
    email: string,
    product: string,
    expirationDate: string,
    hasExpired: boolean,
    npm: boolean,
    lineNumber: number,
    tier: string,
    firstName: string,
    lastName: string,
    account: string,
    usage?: UsageData
}

export interface CustomerSubscription {
    product: string,
    email: string,
    firstName: string,
    lastName: string,
    expiryDate: string,
    isNpmPackageOnly: boolean,
    subscriptionStatus: CustomerSubscriptionStatus,
    usage: UsageData
}

export enum CustomerSubscriptionStatus {
    NULL = 'NULL', 
    FREE = 'FREE', 
    PAID = 'PAID'
}

export enum PropNames {
    monthlyRestUsage = 'Monthly Usage',
    monthlyGuiUsage = 'Monthly GUI Usage',
    maximumInputSize = 'Input Size',
    responseTime = 'Support Response Time'
}

export class SubsData {

    public static statusTextMap: Map<CustomerSubscriptionStatus, string> = SubsData.createStatusTextMap();

    private static createStatusTextMap() {
        const statusTextMap: Map<CustomerSubscriptionStatus, string> = new Map();
        statusTextMap.set(CustomerSubscriptionStatus.NULL, "None");
        statusTextMap.set(CustomerSubscriptionStatus.FREE, "Free Subscription");
        statusTextMap.set(CustomerSubscriptionStatus.PAID, "Pro Subscription");
        return statusTextMap;
    }

    static populateCustomerSubscriptionData(rawResult: RawSubscription): CustomerSubscription | undefined {
        let customerSubscription: CustomerSubscription | undefined = undefined;
        if (rawResult) {
            customerSubscription = {
                product: rawResult.product,
                email: rawResult.email,
                firstName: rawResult.firstName,
                lastName: rawResult.lastName,
                expiryDate: rawResult.expirationDate,
                isNpmPackageOnly: rawResult.npm,
                subscriptionStatus: rawResult.tier as CustomerSubscriptionStatus,
                usage: rawResult.usage!
            }
        }
        return customerSubscription;
    }

    static initUsageData: UsageData = {
        userId: '',
        productCode: '',
        userTotalUsage: -1,
        userApiUsageCounter: -1,
        userGuiUsageCounter: -1
    }

    static initCustomerSubscription: CustomerSubscription = {
        product: '',
        email: '',
        firstName: '',
        lastName: '',
        expiryDate: '',
        isNpmPackageOnly: false,
        subscriptionStatus: CustomerSubscriptionStatus.NULL,
        usage: SubsData.initUsageData
    }

}


